import { useEffect, useId, useState } from 'react';

import { paths } from '@farmersdog/constants';
import {
  PageWidth,
  Button,
  Text,
  type TextVariant,
  useViewport,
} from '@farmersdog/corgi-x';

import { Picture } from '../../../components/Picture';

import { freshSources, kibbleSources, meatvegSources } from './assets';
import styles from './WhyFreshIsBest.css';

export interface WhyFreshIsBestProps {
  breed: string;
}

export function WhyFreshIsBest({ breed }: WhyFreshIsBestProps) {
  const [hasMounted, setHasMounted] = useState(false);
  const id = useId();

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;

  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-40'
    : 'heading-28';

  return (
    <section aria-labelledby={id} className={styles.section}>
      <div className={styles.background}>
        <Picture
          sources={freshSources}
          alt="fresh bowl"
          className={styles.fresh}
          height="389"
          width="389"
        />
        <Picture
          sources={kibbleSources}
          alt="kibble bowl"
          className={styles.kibble}
          height="389"
          width="389"
        />
      </div>
      <PageWidth className={styles.content}>
        <Text
          id={id}
          as="h2"
          color="kale-3"
          variant={titleVariant}
          weight="bold"
        >
          Why fresh is best for your {breed}
        </Text>
        <div>
          <Picture
            sources={meatvegSources}
            alt="meat and veggie"
            className={styles.icon}
            width="117"
            height="91"
          />
        </div>
        <Text
          className={styles.text}
          as="p"
          variant="article-20"
          color="charcoal-3"
        >
          Highly processed kibble can contribute to many issues that can
          compromise your {breed}’s health. Recipes from The Farmer’s Dog are
          made with fresh, human-grade ingredients, steamed to retain nutrients,
          and pre-portioned to help maintain weight.
        </Text>
        <Button className={styles.cta} type="anchor" href={paths.PATH_SIGNUP}>
          Feed Fresh Today
        </Button>
      </PageWidth>
    </section>
  );
}
